var map = {
	"./en-US/settings.json": [
		2127,
		2127
	],
	"./en-US/translation.json": [
		9833,
		9833
	],
	"./pl/settings.json": [
		4031,
		4031
	],
	"./pl/translation.json": [
		7561,
		7561
	],
	"./pt-BR/settings.json": [
		2512,
		2512
	],
	"./pt-BR/translation.json": [
		5804,
		5804
	],
	"./uk/settings.json": [
		3559,
		3559
	],
	"./uk/translation.json": [
		6769,
		6769
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2096;
module.exports = webpackAsyncContext;